export default __webpack_public_path__ + "static/media/ic-para-color.51aa6e2a.svg";